import React, { useState, useContext, useEffect } from "react";
import "./LoginPage.css";
import { Link, useNavigate } from "react-router-dom";

import Cookies from "js-cookie";
import { Context } from "../../../utils/context";
import LoginLottie from "./LoginLottie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { getData } from "../../../utils/api";

const LoginPage = () => {
  const {
    postData,
    signin,
    setSignin,
    usertype,
    setUsertype,
    IMG_URL,
  } = useContext(Context);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [showErrorModal, setShowErrorModal] = useState();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validateForm = () => {
    let errors = {};
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      errors.email = "Enter a valid email address";
    }

    if (!formData.password.trim()) {
      errors.password = "Password is required";
    }

    return errors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      try {
        const response = await postData("/common/auth/admin-login", formData);

        if (response.success) {
          setSignin(response.success);
          setUsertype(response?.data?.role);

          Cookies.set("ollypetshop_admin_security", response.data?.token, {
            expires: 365,
          });

          if (response?.data?.role === "demo") {
            navigate("/demo");
          } else if (response?.data?.role?.length) {
            navigate("/advanceDashboard");
          }
        } else {
          setShowErrorModal(response);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const errorStyle = {
    color: "#e63946",
    fontSize: "0.85rem",
    marginTop: "4px",
    display: "block",
  };

  const [appSetup, setAppSetup] = useState({});
  const GetAppSetup = async () => {
    const response = await getData(`/common/masters/app-setup`);
    if (response?.success) {
      setAppSetup(response?.data);
    }
  };

  useEffect(() => {
    GetAppSetup();
  }, []);

  return (
    <section className="Login">
      <div className="container p-0">
        <div className="row align-items-center justify-content-center min-vh-100 g-0">
          <div className="col-xl-9 col-lg-10 col-12">
            <div className="card login-card-container border-0 overflow-hidden">
              <div className="row g-0">
                {/* Left Image Side */}
                <div className="col-md-6  ">
                  <div className="login-img-wrapper d-md-flex align-items-center justify-content-center ">
                    <img
                      src={IMG_URL + appSetup?.logo}
                      alt="Login Visual"
                      className="img-fluid login-hero-img"
                    />
                  </div>
                </div>

                {/* Right Form Side */}
                <div className="col-md-6 col-12 d-flex align-items-center">
                  <div className="card-body login-form-body p-3">
                    <h2 className="heading_text">Welcome Back</h2>
                    <p className="sub_text">
                      Enter your credentials to access your account dashboard.
                    </p>

                    {showErrorModal?.success
                      ? null
                      : showErrorModal?.errors && (
                          <div className="server-error-message mb-3">
                            <span style={errorStyle}>
                              {showErrorModal?.errors}
                            </span>
                          </div>
                        )}

                    <form onSubmit={handleSubmit} role="form">
                      <div className="form-group mb-3 text-start">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="email_txt form-label"
                        >
                          Email Address
                        </label>
                        <div className="form-control-email">
                          <input
                            type="email"
                            className="form-control inputForm"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder="e.g. name@company.com"
                            name="email"
                            value={formData.email}
                            onChange={(e) => {
                              handleChange(e);
                              setErrors((prev) => ({ ...prev, email: "" }));
                            }}
                          />
                        </div>
                        {errors.email && (
                          <span style={errorStyle}>{errors.email}</span>
                        )}
                      </div>

                      <div className="form-group mb-4 text-start">
                        <label
                          htmlFor="exampleInputPassword1"
                          className="email_txt form-label"
                        >
                          Password
                        </label>
                        <div className="form-control-email input-group password_section">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control inputForm"
                            id="exampleInputPassword1"
                            placeholder="Enter password"
                            name="password"
                            value={formData.password}
                            onChange={(e) => {
                              handleChange(e);
                              setErrors((prev) => ({ ...prev, password: "" }));
                            }}
                          />
                          <span
                            className="input-group-text password-toggle-icon"
                            onClick={togglePasswordVisibility}
                          >
                            <FontAwesomeIcon
                              icon={showPassword ? faEye : faEyeSlash}
                            />
                          </span>
                        </div>
                        {errors.password && (
                          <span style={errorStyle}>{errors.password}</span>
                        )}
                      </div>

                      <button
                        type="submit"
                        className="btn sign-in-button w-100"
                      >
                        Login
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginPage;
